const Auth = {
    login: () => 'login/admin',
    logout: () => 'logout',
    checkAuthorization: () => 'checkAuthorization',
}
export default Auth
